<template>
	<button
		v-if="shown"
		type="button"
		class="chat-header-button"
		:class="{ 'chat-header-button--hot': unread > 0, 'chat-header-button--open': open }"
		:title="$t('chat.chats')"
		:aria-label="label"
		:aria-expanded="open ? 'true' : 'false'"
		@click="toggle"
	>
		<chat-icon name="chat" :size="24" />
		<span v-if="unread > 0" class="chat-header-button__badge">{{ badge }}</span>
		<span v-else-if="needsLogin" class="chat-header-button__dot" />
	</button>
</template>

<script>
	import { unreadBadgeLabel } from '@/services/chat/channels';
	import { chatPhase, chatStore, toggleDrawer, totalUnread } from '@/services/chat/chatStore';
	import ChatIcon from './ChatIcon.vue';

	export default {
		name: 'ChatHeaderButton',
		components: { ChatIcon },
		computed: {
			phase() {
				return chatPhase();
			},
			shown() {
				return this.phase !== 'off';
			},
			needsLogin() {
				return this.phase === 'needsLogin';
			},
			open() {
				return chatStore.drawerOpen;
			},
			unread() {
				return totalUnread();
			},
			badge() {
				return unreadBadgeLabel(this.unread);
			},
			label() {
				const label = this.$t('chat.chats');
				return this.unread > 0 ? `${label}, ${this.$t('chat.list_unread', { count: this.unread })}` : label;
			},
		},
		methods: {
			toggle() {
				toggleDrawer();
			},
		},
	};
</script>

<style scoped>
	.chat-header-button {
		position: relative;
		display: flex;
		flex-shrink: 0;
		align-items: center;
		justify-content: center;
		width: 40px;
		height: 40px;
		margin: 0 8px;
		color: var(--white);
		background: #08cc04;
		border: 0;
		border-radius: 9999px;
		cursor: pointer;
		transition: background-color 0.15s ease, color 0.15s ease;
	}

	.chat-header-button:hover,
	.chat-header-button--open {
		background-color: #037800;
	}

	.chat-header-button--hot {
		animation: chat-header-halo 2s infinite;
	}

	.chat-header-button__badge {
		position: absolute;
		top: 2px;
		right: 0;
		min-width: 18px;
		height: 18px;
		padding: 0 5px;
		font-size: 10px;
		font-weight: 800;
		line-height: 18px;
		text-align: center;
		color: var(--white);
		background: var(--primary);
		border-radius: 9999px;
		font-variant-numeric: tabular-nums;
	}

	.chat-header-button__dot {
		position: absolute;
		top: 7px;
		right: 7px;
		width: 9px;
		height: 9px;
		background: var(--warning);
		border: 2px solid var(--white);
		border-radius: 9999px;
	}

	@keyframes chat-header-halo {
		0% {
			box-shadow: 0 0 0 0 rgba(14, 183, 70, 0.4);
		}
		70% {
			box-shadow: 0 0 0 10px rgba(14, 183, 70, 0);
		}
		100% {
			box-shadow: 0 0 0 0 rgba(14, 183, 70, 0);
		}
	}

	@media (prefers-reduced-motion: reduce) {
		.chat-header-button--hot {
			animation: none;
		}
	}
</style>
